export default class CDNUpdate {

  constructor() {
    this.form = document.getElementById('cdn_update');
    const self = this;

    if (this.form) {
      window.deleteCertificateFromCDN = options => {
        self.onDeleteFromList(options.certificateId, self.form, 'cdn_update_deleted_certificates', 'grid_cdn_certificate', 'certificate')
      }
      window.deleteDomainRecordFromCDN = options => {
        self.onDeleteFromList(options.cdnDomainRecordId, self.form, 'cdn_update_deleted_domains_records', 'grid_cdn_domain_record', 'cdn_domain_record')
      }
    }
  }

  onDeleteFromList(value, form, inputId, tableId, buttonKey) {
    const input = form.querySelector(`#${ inputId}`);
    const inputValue = JSON.parse(input.value || '[]');
    inputValue.push(value);
    input.value = JSON.stringify(inputValue);

    const table = document.querySelector(`#${ tableId }`);
    const rows = table.querySelectorAll('tbody tr');
    for (const row of rows) {
      console.log(`${ buttonKey }_${ value }`);
      const buttonExists = row.querySelector(`.${ buttonKey }_${ value }`);
      if (buttonExists) row.remove()
    }

    const tableBody = table.querySelector('tbody');
    const rowsLength = tableBody.querySelectorAll('tr').length;
    if (rowsLength < 1) {
      tableBody.innerHTML = `
        <tr class="no-data-row">
          <td colspan="3" class="text-center border-bottom">No data available at this time</td>
        </tr>
      `
    }
  }
}
